import { isDataSaverMode } from "@/services/playbackUrls";

/**
 * Fonctions d'import partagées entre lazy() et le préchargement :
 * un seul téléchargement du code de chaque page.
 */
export const loadSearch = () => import("@/pages/Search");
export const loadCreate = () => import("@/pages/Create");
export const loadMarketplace = () => import("@/pages/Marketplace");
export const loadProfile = () => import("@/pages/Profile");
export const loadLegalDocuments = () => import("@/pages/LegalDocuments");

const LOADERS_BY_PATH: Record<string, () => Promise<unknown>> = {
  "/search": loadSearch,
  "/create": loadCreate,
  "/marketplace": loadMarketplace,
  "/profile": loadProfile,
  "/legal": loadLegalDocuments,
};

const swallow = (error: unknown) => console.error("Préchargement de page impossible:", error);

/** Précharge le code d'une page à partir de son chemin (sans effet si inconnu). */
export const preloadPage = (path: string) => {
  if (isDataSaverMode()) return;
  LOADERS_BY_PATH[path]?.().catch(swallow);
};

/** Précharge toutes les pages l'une après l'autre, 4 s après le premier affichage, au repos. */
export const scheduleIdlePreload = () => {
  if (isDataSaverMode()) return;
  window.setTimeout(() => {
    const run = async () => {
      for (const load of Object.values(LOADERS_BY_PATH)) {
        await load().catch(swallow);
      }
    };
    const idle = (window as any).requestIdleCallback as ((cb: () => void) => void) | undefined;
    if (idle) idle(() => void run());
    else window.setTimeout(() => void run(), 0);
  }, 4000);
};
